import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useIsDraftPostsEnabled } from '@ms/yammer-hooks/dist/session';

import { UseUIFeatureCheck } from '../types';

export const useIsPostOnBehalfOfDraftEnabled: UseUIFeatureCheck = () => {
  const isPostOnBehalfOfDraftFeatureEnabled = useExperimentTreatmentWithoutReporting(Experiment.POBODrafts) === true;
  const isDraftPostsEnabled = useIsDraftPostsEnabled();

  return isPostOnBehalfOfDraftFeatureEnabled && isDraftPostsEnabled;
};
